import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../../../StyleSheet/MainComponent/FormDetails/FormTabs.scss";
import BasicForms from "./BasicForms";
import AddressForm from "./AddressForm";
import {
  SetBasiformsID,
  SetAddressId,
  SetIdVeriications,
  setBankDetailsId,
  SetEducationDetails,
  setfamliydetailsid,
  SetPreviousEmployeeID,
  getSideBarfilesActions,
  SetDeclarationId,
  SetEsiFormIdActions,
  SetJobOfferID,
  SetActiveTabs,
  setEmployeeProfileDATASActions,
  SetEmployeeProfileDetailsID,
  CreateResponse_store,
  setTheFirstNames,
  settheJobinfoBranchEmployeeProfile,
  setbankCounts,
  setTheTransactionID,
  settheBankHolderName,
} from "../../../Redux/Slice";
import IDverify from "./IDverify";
import BankDetails from "./BankDetails";
import { NavLink } from "react-router-dom";
import EducationDetails from "./EducationDetails";
import PreviousEmp from "./PreviousEmp";
import FamilyDetails from "./FamilyDetails";
import DecalarationFrom from "./DecalarationFrom";
import ESIfrom from "./ESIfrom";
import Joboffer from "./Joboffer";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import { useNavigate } from "react-router-dom";
import BackImage from "../../../Assets/AppComponent/Overall_icons/UDS Needs Image-20.svg";
import ActiveEmc from "../../../Assets/AppComponent/Group 309.svg";
import InActiveEmc from "../../../Assets/AppComponent/Group 309 (1).svg";

const FormTabs = () => {
  const state = useSelector((state) => state);
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive,
  );

  console.log(state, "dskldaklsdlkaslk");
  const navigate = useNavigate();

  const dispatch = useDispatch();
  const [counts, setCounts] = useState(1);
  const [UserName, setUserName] = useState("");
  const [RoleName, setRoleNames] = useState("");
  const [EmpActive, setEmpActive] = useState();

  const [ProfileImg, setProfileImg] = useState();
  const CountingFunctions = (countNumber) => {
    setCounts(countNumber);
  };

  const maxLength = 20;
  const ellipsis = "...";

  const [TabNmaes, setTabnames] = useState({ clientname: "", branchname: "" });
  let payloads = {
    search: "",
    page_size: 10,
    page: 1,
    // ids: state.ClientBranchIDs.EmployeeDetailsProfile,
    ids:
      state.BasicFormCreated.user_ID == ""
        ? state.EmployeeProfile.EmployeeProfileList.id
        : state.BasicFormCreated.user_ID,
    // is_pending: state.ClientBranchIDs.IS_pendingDetails,
  };

  // useEffect(() => {

  //   if (
  //     // state.EmployeeProfile.EmployeeProfileList.id != undefined &&
  //     state.ClientBranchIDs.EmployeeDetailsProfile !="" &&
  //     state.ClientBranchIDs.EmployeeDetailsProfile != undefined &&
  //     state.ClientBranchIDs.EmployeeDetailsProfile != ""
  //   ) {
  //     dispatch(setEmployeeProfileDATASActions(payloads));

  //   }
  //     //  dispatch(SetEmployeeProfileDetailsID(state.BasicFormCreated.user_ID == ""
  //     //   ? state.EmployeeProfile.EmployeeProfileList.id
  //     //   : state.BasicFormCreated.user_ID))

  // }, [state.ClientBranchIDs.EmployeeDetailsProfile ,state.BasicFormCreated.user_ID ,state.FormsIDList.ActiveTabs]);

  useEffect(() => {
    if (
      // state.EmployeeProfile.EmployeeProfileList.id != undefined &&
      state.ClientBranchIDs.EmployeeDetailsProfile != "" &&
      state.ClientBranchIDs.EmployeeDetailsProfile != undefined &&
      state.ClientBranchIDs.EmployeeDetailsProfile != ""
    ) {
      if (
        state.FormsIDList.ActiveTabs == 10 &&
        state.EmployeeProfile.EmployeeProfileList.is_job_description == true
      ) {
        dispatch(setEmployeeProfileDATASActions(payloads));
      } else if (state.FormsIDList.ActiveTabs != 10) {
        dispatch(setEmployeeProfileDATASActions(payloads));
      }
      console.log(state.FormsIDList.ActiveTabs, "aiudsposaidoasd");
    }
    //  dispatch(SetEmployeeProfileDetailsID(state.BasicFormCreated.user_ID == ""
    //   ? state.EmployeeProfile.EmployeeProfileList.id
    //   : state.BasicFormCreated.user_ID))
  }, [
    state.ClientBranchIDs.EmployeeDetailsProfile,
    state.BasicFormCreated.user_ID,
  ]);
  // console.log(state.ClientBranchIDs.EmployeeDetailsProfile , "aiudsposaidoasdaiudsposaidoasd",state.EmployeeProfile.EmployeeProfileList);

  useEffect(() => {
    if (
      state.NeededdatasListed.clientNameList &&
      typeof state.NeededdatasListed.clientNameList === "string"
    ) {
      const maxLength = 10; // Set your desired maximum length
      const ellipsis = "..."; // Set your ellipsis string

      const truncatedClientName =
        state.NeededdatasListed.clientNameList.length > maxLength
          ? `${state.NeededdatasListed.clientNameList.substring(
              0,
              maxLength,
            )}${ellipsis}`
          : state.NeededdatasListed.clientNameList;
      console.log("Truncated Client Name:", truncatedClientName);

      const truncatedBranchNameName =
        state.NeededdatasListed.BranchNameListed.length > maxLength
          ? `${state.NeededdatasListed.BranchNameListed.substring(
              0,
              maxLength,
            )}${ellipsis}`
          : state.NeededdatasListed.BranchNameListed;

      setTabnames({
        ...TabNmaes,
        clientname: truncatedClientName,
        branchname: truncatedBranchNameName,
      });
      // Use `truncatedClientName` in your component
      // console.log("Truncated Client Name:", truncatedClientName);
    } else {
      // Handle the case when clientNameList is undefined or not a string
      // console.log("Client Name List is undefined or not a string");
    }
  }, [state.NeededdatasListed]);

  useEffect(() => {
    if (
      state.EmployeeProfile.EmployeeProfileList != "" &&
      state.EmployeeProfile.EmployeeProfileList != null
    ) {
      if (
        state.EmployeeProfile.EmployeeProfileList.id != undefined &&
        state.ClientBranchIDs.EmployeeDetailsProfile != ""
      ) {
        setRoleNames(
          state.EmployeeProfile.EmployeeProfileList.user_id.user_uid,
        );
        setEmpActive(
          state.EmployeeProfile.EmployeeProfileList.user_id.is_active,
        );
      }
    }
    if (
      state.EmployeeProfile.EmployeeProfileList.id != undefined &&
      state.ClientBranchIDs.EmployeeDetailsProfile != ""
    ) {
      if (
        state.EmployeeProfile.EmployeeProfileList != "" &&
        state.EmployeeProfile.EmployeeProfileList != undefined &&
        state.EmployeeProfile.EmployeeProfileList.user_id != null &&
        state.EmployeeProfile.EmployeeProfileList.user_id != undefined &&
        state.EmployeeProfile.EmployeeProfileList.user_id.first_name != "" &&
        state.EmployeeProfile.EmployeeProfileList.user_id.first_name !=
          undefined
      ) {
        dispatch(
          setTheFirstNames(
            state.EmployeeProfile.EmployeeProfileList.user_id.first_name,
          ),
        );
      }

      if (
        state.EmployeeProfile.EmployeeProfileList.basic_info != null &&
        state.EmployeeProfile.EmployeeProfileList.basic_info != undefined
        //    &&
        // state.NumberCounts.Editable != 2
      ) {
        dispatch(
          SetBasiformsID(
            state.EmployeeProfile.EmployeeProfileList.basic_info.id,
          ),
        );
      } ///---to--make ---as readonly
      else if (
        // state.NumberCounts.Editable == 2 &&
        state.EmployeeProfile.EmployeeProfileList == "" &&
        state.EmployeeProfile.EmployeeProfileList.basic_info == null
      ) {
        dispatch(SetBasiformsID(""));
      }

      if (
        state.EmployeeProfile.EmployeeProfileList.address_details != null &&
        state.EmployeeProfile.EmployeeProfileList.address_details != undefined
        //   &&
        // state.NumberCounts.Editable != 2
      ) {
        dispatch(
          SetAddressId(
            state.EmployeeProfile.EmployeeProfileList.address_details.id,
          ),
        );
      } else if (
        // state.NumberCounts.Editable == 2 &&
        state.EmployeeProfile.EmployeeProfileList.address_details != null &&
        state.EmployeeProfile.EmployeeProfileList.address_details != undefined
      ) {
        dispatch(
          SetAddressId(
            state.EmployeeProfile.EmployeeProfileList.address_details.id,
          ),
        );
      }

      if (
        state.EmployeeProfile.EmployeeProfileList.job_description != null &&
        state.EmployeeProfile.EmployeeProfileList.job_description != undefined
        //    &&
        // state.NumberCounts.Editable != 2
      ) {
        dispatch(
          SetJobOfferID(
            state.EmployeeProfile.EmployeeProfileList.job_description.id,
          ),
        );
      } ///---for---readonly
      else if (
        // state.NumberCounts.Editable == 2 &&
        state.EmployeeProfile.EmployeeProfileList.job_description != null &&
        state.EmployeeProfile.EmployeeProfileList.job_description != undefined
      ) {
        dispatch(
          SetJobOfferID(
            state.EmployeeProfile.EmployeeProfileList.job_description.id,
          ),
        );
      } ///-----edit or view

      if (
        state.EmployeeProfile.EmployeeProfileList != undefined &&
        state.EmployeeProfile.EmployeeProfileList != null &&
        state.EmployeeProfile.EmployeeProfileList.id_verification != null &&
        state.EmployeeProfile.EmployeeProfileList.id_verification !=
          undefined &&
        state.EmployeeProfile.EmployeeProfileList.id != undefined &&
        state.EmployeeProfile.EmployeeProfileList.id_verification.id !=
          undefined
        //   &&
        // state.NumberCounts.Editable != 2
      ) {
        if (
          state.EmployeeProfile.EmployeeProfileList.basic_info != null &&
          state.EmployeeProfile.EmployeeProfileList.basic_info != undefined
        ) {
          dispatch(
            SetBasiformsID(
              state.EmployeeProfile.EmployeeProfileList.basic_info.id,
            ),
          );
        }

        if (
          state.EmployeeProfile.EmployeeProfileList.address_details != null &&
          state.EmployeeProfile.EmployeeProfileList.address_details != undefined
        ) {
          dispatch(
            SetAddressId(
              state.EmployeeProfile.EmployeeProfileList.address_details.id,
            ),
          );
        }
        dispatch(
          SetIdVeriications(
            state.EmployeeProfile.EmployeeProfileList.id_verification.id,
          ),
        );
      }

      if (
        state.EmployeeProfile.EmployeeProfileList != undefined &&
        state.EmployeeProfile.EmployeeProfileList != null &&
        state.EmployeeProfile.EmployeeProfileList.bank_details != null &&
        state.EmployeeProfile.EmployeeProfileList.bank_details != undefined &&
        state.EmployeeProfile.EmployeeProfileList.id != undefined &&
        state.EmployeeProfile.EmployeeProfileList.bank_details.id != undefined
        //   &&
        // state.NumberCounts.Editable != 2
      ) {
        dispatch(
          setBankDetailsId(
            state.EmployeeProfile.EmployeeProfileList.bank_details.id,
          ),
        );
        // dispatch(CreateResponse_store(state.EmployeeProfile.EmployeeProfileList.is_bank_details))
      } else if (
        // state.NumberCounts.Editable == 2 &&
        state.EmployeeProfile.EmployeeProfileList != null &&
        state.EmployeeProfile.EmployeeProfileList.bank_details != null &&
        state.EmployeeProfile.EmployeeProfileList.bank_details != undefined &&
        state.EmployeeProfile.EmployeeProfileList.id != undefined &&
        state.EmployeeProfile.EmployeeProfileList.bank_details.id != undefined
      ) {
        dispatch(
          setBankDetailsId(
            state.EmployeeProfile.EmployeeProfileList.bank_details.id,
          ),
        );
        // dispatch(CreateResponse_store(false))
      }

      if (
        state.EmployeeProfile.EmployeeProfileList != undefined &&
        state.EmployeeProfile.EmployeeProfileList != null &&
        state.EmployeeProfile.EmployeeProfileList.education_details != null &&
        state.EmployeeProfile.EmployeeProfileList.education_details !=
          undefined &&
        state.EmployeeProfile.EmployeeProfileList.id != undefined &&
        state.EmployeeProfile.EmployeeProfileList.education_details.id !=
          undefined
        //   &&
        // state.NumberCounts.Editable != 2
      ) {
        dispatch(
          SetEducationDetails(
            state.EmployeeProfile.EmployeeProfileList.education_details.id,
          ),
        );
        console.log(
          state.EmployeeProfile.EmployeeProfileList.education_details,
          "state.EmployeeProfile.EmployeeProfileList.education_details",
        );
      } else if (
        // state.NumberCounts.Editable == 2 &&
        state.EmployeeProfile.EmployeeProfileList != null &&
        state.EmployeeProfile.EmployeeProfileList.education_details != null &&
        state.EmployeeProfile.EmployeeProfileList.education_details !=
          undefined &&
        state.EmployeeProfile.EmployeeProfileList.id != undefined &&
        state.EmployeeProfile.EmployeeProfileList.education_details.id !=
          undefined
      ) {
        dispatch(
          SetEducationDetails(
            state.EmployeeProfile.EmployeeProfileList.education_details.id,
          ),
        );
      }

      if (
        // state.NumberCounts.Editable == 2 &&
        (state.EmployeeProfile.EmployeeProfileList != null &&
          state.EmployeeProfile.EmployeeProfileList.education_details ==
            null) ||
        state.EmployeeProfile.EmployeeProfileList.education_details == undefined
      ) {
        dispatch(SetEducationDetails(""));
      }

      if (
        state.EmployeeProfile.EmployeeProfileList.employee_previous != null &&
        state.EmployeeProfile.EmployeeProfileList.employee_previous != undefined
        //    &&
        // state.NumberCounts.Editable != 2
      ) {
        dispatch(
          SetPreviousEmployeeID(
            state.EmployeeProfile.EmployeeProfileList.employee_previous.id,
          ),
        );
      } else if (
        // state.NumberCounts.Editable == 2 &&
        state.EmployeeProfile.EmployeeProfileList.employee_previous != null &&
        state.EmployeeProfile.EmployeeProfileList.employee_previous != undefined
      ) {
        dispatch(
          SetPreviousEmployeeID(
            state.EmployeeProfile.EmployeeProfileList.employee_previous.id,
          ),
        );
      }

      if (
        state.EmployeeProfile.EmployeeProfileList.declaration_form != null &&
        state.EmployeeProfile.EmployeeProfileList.declaration_form != undefined
        //   &&
        // state.NumberCounts.Editable != 2
      ) {
        dispatch(
          SetDeclarationId(
            state.EmployeeProfile.EmployeeProfileList.declaration_form.id,
          ),
        );
      } else if (
        // state.NumberCounts.Editable == 2 &&
        state.EmployeeProfile.EmployeeProfileList.declaration_form != null &&
        state.EmployeeProfile.EmployeeProfileList.declaration_form != undefined
      ) {
        dispatch(
          SetDeclarationId(
            state.EmployeeProfile.EmployeeProfileList.declaration_form.id,
          ),
        );
      }

      if (
        state.EmployeeProfile.EmployeeProfileList.esi_form != null &&
        state.EmployeeProfile.EmployeeProfileList.esi_form != undefined
        //   &&
        // state.NumberCounts.Editable != 2
      ) {
        dispatch(
          SetEsiFormIdActions(
            state.EmployeeProfile.EmployeeProfileList.esi_form.id,
          ),
        );

        // navigate("/formtab");
      } //---reaad--only
      else if (
        // state.NumberCounts.Editable == 2 &&
        state.EmployeeProfile.EmployeeProfileList.esi_form != null &&
        state.EmployeeProfile.EmployeeProfileList.esi_form != undefined
      ) {
        dispatch(
          SetEsiFormIdActions(
            state.EmployeeProfile.EmployeeProfileList.esi_form.id,
          ),
        );

        // navigate("/formtab");
        ///--profile 000imag
        //    if(state.EmployeeProfile.EmployeeProfileList.esi_form != null &&
        // state.EmployeeProfile.EmployeeProfileList.esi_form != undefined){
        //     // setProfileImg
        //    }
      }
    }
    // console.log(
    //   BankDetail,r
    //   "jljl",
    //   state.EmployeeProfile.EmployeeProfileList.id
    // );

    if (
      state.EmployeeProfile.EmployeeProfileList != undefined &&
      state.EmployeeProfile.EmployeeProfileList != null &&
      state.EmployeeProfile.EmployeeProfileList.bank_details != null &&
      state.EmployeeProfile.EmployeeProfileList.bank_details != undefined &&
      state.EmployeeProfile.EmployeeProfileList.id != undefined &&
      state.EmployeeProfile.EmployeeProfileList.bank_details != undefined
      //   &&
      // state.NumberCounts.Editable != 2
    ) {
      dispatch(
        setBankDetailsId(
          state.EmployeeProfile.EmployeeProfileList.bank_details.id,
        ),
      );
      dispatch(
        settheBankHolderName(
          state.EmployeeProfile.EmployeeProfileList.bank_details
            .account_holder_name,
        ),
      );
    } else if (
      // state.NumberCounts.Editable == 2 &&
      state.EmployeeProfile.EmployeeProfileList != null &&
      state.EmployeeProfile.EmployeeProfileList.bank_details == null &&
      state.EmployeeProfile.EmployeeProfileList.bank_details == undefined &&
      state.EmployeeProfile.EmployeeProfileList.bank_details == undefined
    ) {
      dispatch(setBankDetailsId(""));
      dispatch(setTheTransactionID(""));
      dispatch(setbankCounts(""));
    }
  }, [
    state.EmployeeProfile.EmployeeProfileList,
    state.FormsIDList.ActiveTabs,
    // state.FormsIDList.ActiveTabs != 2
    // && state.FormsIDList.ActiveTabs != 10
  ]);

  // console.log( state.EmployeeProfile.EmployeeProfileList , "state.EmployeeProfile.EmployeeProfileList");

  useEffect(() => {
    if (
      state.NumberCounts.Editable == 1 &&
      state.ClientBranchIDs.ApproveRequest == 2
    ) {
      dispatch(getSideBarfilesActions("Approve Request"));
    }
    if (
      state.NumberCounts.Editable == 2 &&
      state.ClientBranchIDs.ApproveRequest == 4
    ) {
      dispatch(getSideBarfilesActions("Onboarding"));
    }
    if (
      state.NumberCounts.Editable == 2 &&
      state.ClientBranchIDs.ApproveRequest == 5
    ) {
      dispatch(getSideBarfilesActions("My Onboarding List"));
    }

    if (
      // state.NumberCounts.Editable == 2 &&
      state.ClientBranchIDs.ApproveRequest == 3
    ) {
      dispatch(getSideBarfilesActions("Client"));
    }

    if (
      state.NumberCounts.Editable == 1 &&
      state.ClientBranchIDs.ApproveRequest == 6
    ) {
      dispatch(getSideBarfilesActions("Overview"));
    }

    if (
      state.NumberCounts.Editable == 1 &&
      state.ClientBranchIDs.ApproveRequest == 7
    ) {
      dispatch(getSideBarfilesActions("Onboard Overview"));
    }
  }, [
    state.NumberCounts.Editable,
    state.SideBarFiles.SideBarFile,
    state.ClientBranchIDs.ApproveRequest,
  ]);
  console.log(
    state.ClientBranchIDs.ApproveRequest,
    "ApproveRequest",
    state.NumberCounts.Editable,
  );

  // console.log(state.ClientBranchIDs.ApproveRequest , "Employeee",state.NumberCounts.Editable , state.SideBarFiles.SideBarFile);
  return (
    <>
      <div className="FormTab">
        <div className={stateDisplay ? "POPUP" : "outerPOPUP"}>
          {/* <div className={stateDisplay ? "outterContent" : "inner-Content"}> */}
          <div className="Header-Details ClientBranch row">
            <div
              class="col-sm-7 auto"
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                justifyContent: "flex-start",
                paddingLeft: "0px",
              }}
            >
              <h3>Employee Form Details </h3>
              {/* {!state.ClientBranchIDs.StatusBtn &&
            state.NumberCounts.Editable != 2 ? (
              <ul class="breadcrumb">
                {state.ClientBranchIDs.DashboardIDs == 1 ? (
                  <>
               
                    <li class="breadcrumb-item">
                      <NavLink
                        style={{ textDecoration: "none", color: "#333333" }}
                        to={"/employeeVerifylist"}
                        onClick={(e) => {
                          // dispatch(
                          //   getSideBarfilesActions("Employee Verification")
                          // );
                          dispatch(getSideBarfilesActions("Approve Request"));
                        }}
                      >
                        Employee list
                      </NavLink>
                    </li>
                    <li class="breadcrumb-item">
                      <NavLink
                        style={{ textDecoration: "none", color: "#333333" }}
                        to={"/employeeprofile"}
                        onClick={(e) => {
                          dispatch(getSideBarfilesActions("Approve Request"));
                        }}
                      >
                        Employee Profile
                      </NavLink>
                    </li>
                  </>
                ) : (
                  <>
                    <li class="breadcrumb-item">

                      <NavLink
                        style={{ textDecoration: "none", color: "#333333" }}
                        // to={"/"}
                        to={
                          state.SideBarFiles.SideBarFile == "OverView"
                            ? "/"
                            : "/onboardDashboard"
                        }
                        onClick={(e) => {
                          dispatch(
                            getSideBarfilesActions(
                              state.SideBarFiles.SideBarFile
                            )
                          );
                        }}
                      >
                        {state.SideBarFiles.SideBarFile}
                      </NavLink>
                    </li>
                    <li class="breadcrumb-item">
                      <NavLink
                        style={{ textDecoration: "none", color: "#333333" }}
                        to={"/employeeVerifylist"}
                        onClick={(e) => {
                          dispatch(
                            getSideBarfilesActions(
                              state.SideBarFiles.SideBarFile
                            )
                          );
                        }}
                      >
                        Employee list
                      </NavLink>
                    </li>
                    <li class="breadcrumb-item">
                      <NavLink
                        style={{ textDecoration: "none", color: "#333333" }}
                        to={"/employeeprofile"}
                        onClick={(e) => {
                          dispatch(
                            getSideBarfilesActions(
                              state.SideBarFiles.SideBarFile
                            )
                          );
                        }}
                      >
                        Employee Profile
                      </NavLink>
                    </li>
                  </>
                )}

                <li class="breadcrumb-item active"> Employee Form Details </li>
              </ul>
            ) : (
              <>
                {state.NumberCounts.Editable != 2 ? (
                  <ul class="breadcrumb">
                    <li class="breadcrumb-item">
                      <NavLink
                        style={{ textDecoration: "none", color: "#333333" }}
                        to={"/client"}
                        onClick={(e) => {
                          dispatch(getSideBarfilesActions("Client"));
                        }}
                      >
                   
                        {TabNmaes.clientname}
                      </NavLink>
                    </li>
                    <li class="breadcrumb-item">
                      <NavLink
                        style={{ textDecoration: "none", color: "#333333" }}
                        to={"/clientbranch"}
                        onClick={(e) => {
                          dispatch(getSideBarfilesActions("Client"));
                        }}
                      >
                        {TabNmaes.branchname}

                      </NavLink>
                    </li>
                    <li class="breadcrumb-item">
                      <NavLink
                        style={{ textDecoration: "none", color: "#333333" }}
                        to={"/clientDetails"}
                        onClick={(e) => {
                          dispatch(getSideBarfilesActions("Client"));
                        }}
                      >
                        Profile
                      </NavLink>
                    </li>
                    <li class="breadcrumb-item">
                      <NavLink
                        style={{ textDecoration: "none", color: "#333333" }}
                        to={"/employeeprofile"}
                        onClick={(e) => {
                          dispatch(getSideBarfilesActions("Client"));
                        }}
                      >
                        Employee Profile
                      </NavLink>
                    </li>

                    <li class="breadcrumb-item active">
                      Employe Form Details{" "}
                    </li>
                  </ul>
                ) : (
                  <>
                    <ul class="breadcrumb">
                      <li class="breadcrumb-item">
                        <NavLink
                          style={{ textDecoration: "none", color: "#333333" }}
                          //   to={"/managerlist"}
                          to={"/fieldagent"}
                          onClick={(e) => {
                            dispatch(getSideBarfilesActions("Onboarding"));
                          }}
                        >
                          Employee List
                        </NavLink>
                      </li>

                      <li class="breadcrumb-item">
                        <NavLink
                          style={{ textDecoration: "none", color: "#333333" }}
                          to={"/employeeprofile"}
                          onClick={(e) => {
                            dispatch(getSideBarfilesActions("Onboarding"));
                          }}
                        >
                          Employe Profile
                        </NavLink>
                      </li>

                      <li class="breadcrumb-item active">
                        Employe Form Details
                      </li>
                    </ul>
                  </>
                )}
              </>
            )} */}
            </div>
          </div>
          <div
            className="row Filters ButtonPrevious"
            style={{ padding: "12px 0px" }}
          >
            <div className="col">
              <button
                className="btn BackImga"
                onClick={(e) => {
                  // navigate("/employeeVerifylist");

                  navigate(
                    state.NumberCounts.Editable != 2
                      ? state.SideBarFiles.SideBarFile == "Approve Request"
                        ? "/employeeprofile"
                        : state.SideBarFiles.SideBarFile == "Overview"
                          ? "/employeeprofile"
                          : state.SideBarFiles.SideBarFile == "Onboard Overview"
                            ? // "/onboardDashboard"
                              "/employeeprofile"
                            : state.SideBarFiles.SideBarFile == "Client" &&
                              // "/clientDetails"
                              "/employeeprofile"
                      : "/employeeprofile",
                    // fieldagent"
                  );
                }}
              >
                <img className="PreviousPages" src={BackImage} />
                <span></span>
              </button>
            </div>
          </div>

          <div className="Header-Details" style={{ marginTop: "20px" }}>
            <div className="InnerDetails">
              <div className="InnerDetailPart">
                <div className="LOGO">
                  <img src={profile2} />
                </div>

                {state.EmployeeProfile.EmployeeProfileList != undefined &&
                state.EmployeeProfile.EmployeeProfileList != null &&
                state.EmployeeProfile.EmployeeProfileList.user_id !=
                  undefined &&
                state.EmployeeProfile.EmployeeProfileList.user_id != null &&
                state.EmployeeProfile.EmployeeProfileList.user_id.first_name.toUpperCase() ? (
                  <p className="EMpCODER">
                    <span>
                      {state.EmployeeProfile.EmployeeProfileList.user_id.first_name.toUpperCase()}
                    </span>
                    <span>
                      <>
                        {" "}
                        Emp Code :{" "}
                        <span>
                          {state.EmployeeProfile.EmployeeProfileList !=
                            undefined &&
                          state.EmployeeProfile.EmployeeProfileList.user_id !=
                            undefined &&
                          state.EmployeeProfile.EmployeeProfileList.user_id !=
                            null &&
                          state.EmployeeProfile.EmployeeProfileList.user_id
                            .user_uid &&
                          (state.EmployeeProfile.EmployeeProfileList.user_id
                            .user_uid !=
                            "") !=
                            "" ? (
                            <>
                              {
                                state.EmployeeProfile.EmployeeProfileList
                                  .user_id.user_uid
                              }
                            </>
                          ) : (
                            <>--</>
                          )}
                        </span>
                      </>
                    </span>
                  </p>
                ) : (
                  <p>{"---"}</p>
                )}
              </div>
              <div className="ROLE">
                <div className="LOGO EMCANDACTIVE">
                  {EmpActive == true && RoleName != "" ? (
                    <>
                      <span>Active</span>
                      <span className="ActiveImage">
                        <img src={ActiveEmc} />
                      </span>
                    </>
                  ) : EmpActive == false && RoleName != "" ? (
                    <>
                      <span>Inactive</span>
                      <span className="ActiveImage">
                        <img src={InActiveEmc} />
                      </span>
                    </>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <div className="row"></div>
              <div class="profile-header">
                <div
                  class="row  align-items-center"
                  style={{ padding: "15px" }}
                >
                  <div class="col ml-md-n2 profile-user-info">
                    <h4 class="user-name mb-0"></h4>
                  </div>
                </div>
                <div className="profile-menu TabsStartHead">
                  <div className="innerTabs">
                    <ul class="nav nav-tabs" id="ex1" role="tablist">
                      <li class="nav-item" role="presentation">
                        <button
                          // class="nav-link active"
                          className={` ButtonCSS nav-link  ${
                            state.FormsIDList.ActiveTabs == 1 ? "active" : ""
                          }`}
                          id="ex3-tab-1"
                          data-bs-toggle="tab"
                          href="#ex3-tabs-1"
                          role="tab"
                          aria-controls="ex3-tabs-1"
                          aria-selected="true"
                          onClick={(e) => {
                            CountingFunctions(1);
                            if (
                              state.EmployeeProfile.EmployeeProfileList
                                .basic_info != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .basic_info != undefined
                            ) {
                              dispatch(
                                SetBasiformsID(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .basic_info.id,
                                ),
                              );
                              dispatch(SetActiveTabs(1));
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .basic_info != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .basic_info != undefined
                            ) {
                              dispatch(SetActiveTabs(1));
                              dispatch(
                                SetBasiformsID(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .basic_info.id,
                                ),
                              );
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .basic_info == null
                            ) {
                              // dispatch(SetBasiformsID(""));

                              dispatch(SetActiveTabs(1));
                            }
                          }}
                        >
                          Basic Information
                        </button>
                      </li>
                      <li class="nav-item " role="presentation">
                        <button
                          //class="nav-link "
                          className={` ButtonCSS  nav-link  ${
                            state.FormsIDList.ActiveTabs == 2 ? "active" : ""
                          }`}
                          id="ex3-tab-2"
                          data-bs-toggle="tab"
                          href="#ex3-tabs-2"
                          role="tab"
                          aria-controls="ex3-tabs-2"
                          aria-selected="false"
                          // onClick={(e) => {
                          //   Counting(2);
                          // }}

                          disabled={
                            state.EmployeeProfile.EmployeeProfileList
                              .address_details == null
                          }
                          //  disabled={
                          //   state.EmployeeProfile.EmployeeProfileList
                          //     .address_details  == null ||
                          //   state.FormsIDList.AddressId == "" ? true : false
                          //  }
                          onClick={(e) => {
                            CountingFunctions(2);
                            if (
                              state.EmployeeProfile.EmployeeProfileList
                                .address_details != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .address_details != undefined
                            ) {
                              dispatch(
                                SetAddressId(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .address_details.id,
                                ),
                              );
                              dispatch(SetActiveTabs(2));
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .address_details != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .address_details != undefined
                            ) {
                              dispatch(SetActiveTabs(2));
                              dispatch(
                                SetAddressId(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .address_details.id,
                                ),
                              );
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .address_details == null
                            ) {
                              // dispatch(SetAddressId(""));
                              dispatch(SetActiveTabs(2));
                            }
                          }}
                        >
                          Address Details
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          //class="nav-link"
                          className={` ButtonCSS nav-link  ${
                            state.FormsIDList.ActiveTabs == 10 ? "active" : ""
                          }`}
                          id="tab10"
                          data-bs-toggle="tab"
                          href="#tabs10"
                          role="tab"
                          aria-controls="tab10"
                          aria-selected="false"
                          disabled={
                            state.EmployeeProfile.EmployeeProfileList
                              .job_description == null ||
                            state.FormsIDList.Job_offer_id == ""
                              ? true
                              : false
                          }
                          onClick={(e) => {
                            CountingFunctions(10);
                            if (
                              state.EmployeeProfile.EmployeeProfileList
                                .job_description != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .job_description != undefined
                            ) {
                              dispatch(
                                SetJobOfferID(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .job_description.id,
                                ),
                              );
                              dispatch(SetActiveTabs(10));
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .job_description != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .job_description != undefined
                            ) {
                              dispatch(SetActiveTabs(10));
                              dispatch(
                                SetJobOfferID(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .job_description.id,
                                ),
                              );
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .job_description == null
                            ) {
                              dispatch(SetJobOfferID(""));
                              dispatch(SetActiveTabs(10));
                            }
                          }}
                        >
                          Job Information
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          //class="nav-link"
                          className={` ButtonCSS  nav-link  ${
                            state.FormsIDList.ActiveTabs == 3 ? "active" : ""
                          }`}
                          id="ex3-tab-3"
                          data-bs-toggle="tab"
                          href="#ex3-tabs-3"
                          role="tab"
                          aria-controls="ex3-tab3"
                          aria-selected="false"
                          disabled={
                            state.EmployeeProfile.EmployeeProfileList
                              .id_verification == null ||
                            state.FormsIDList.Idverify == ""
                          }
                          // onClick={(e) => {
                          //   Counting(2);
                          // }}
                          onClick={(e) => {
                            CountingFunctions(3);
                            if (
                              state.EmployeeProfile.EmployeeProfileList !=
                                undefined &&
                              state.EmployeeProfile.EmployeeProfileList !=
                                null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .id_verification != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .id_verification != undefined &&
                              state.EmployeeProfile.EmployeeProfileList.id !=
                                undefined &&
                              state.EmployeeProfile.EmployeeProfileList
                                .id_verification.id != undefined
                            ) {
                              if (
                                state.EmployeeProfile.EmployeeProfileList
                                  .address_details != null &&
                                state.EmployeeProfile.EmployeeProfileList
                                  .address_details != undefined
                              ) {
                                dispatch(
                                  SetAddressId(
                                    state.EmployeeProfile.EmployeeProfileList
                                      .address_details.id,
                                  ),
                                );
                              }

                              dispatch(
                                SetIdVeriications(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .id_verification.id,
                                ),
                              );

                              if (
                                state.EmployeeProfile.EmployeeProfileList
                                  .basic_info != null &&
                                state.EmployeeProfile.EmployeeProfileList
                                  .basic_info != undefined
                              ) {
                                dispatch(
                                  SetBasiformsID(
                                    state.EmployeeProfile.EmployeeProfileList
                                      .basic_info.id,
                                  ),
                                );
                              }

                              dispatch(SetActiveTabs(3));
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .id_verification != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .id_verification != undefined
                            ) {
                              dispatch(SetActiveTabs(3));
                              if (
                                state.EmployeeProfile.EmployeeProfileList
                                  .basic_info != null &&
                                state.EmployeeProfile.EmployeeProfileList
                                  .basic_info != undefined
                              ) {
                                dispatch(
                                  SetBasiformsID(
                                    state.EmployeeProfile.EmployeeProfileList
                                      .basic_info.id,
                                  ),
                                );
                              }

                              if (
                                state.EmployeeProfile.EmployeeProfileList
                                  .address_details != null &&
                                state.EmployeeProfile.EmployeeProfileList
                                  .address_details != undefined
                              ) {
                                dispatch(
                                  SetAddressId(
                                    state.EmployeeProfile.EmployeeProfileList
                                      .address_details.id,
                                  ),
                                );
                              }

                              dispatch(
                                SetIdVeriications(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .id_verification.id,
                                ),
                              );
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .id_verification == null
                            ) {
                              dispatch(SetIdVeriications(""));
                              if (
                                state.EmployeeProfile.EmployeeProfileList
                                  .basic_info != null &&
                                state.EmployeeProfile.EmployeeProfileList
                                  .basic_info != undefined
                              ) {
                                dispatch(
                                  SetBasiformsID(
                                    state.EmployeeProfile.EmployeeProfileList
                                      .basic_info.id,
                                  ),
                                );
                              }

                              if (
                                state.EmployeeProfile.EmployeeProfileList
                                  .address_details != null &&
                                state.EmployeeProfile.EmployeeProfileList
                                  .address_details != undefined
                              ) {
                                dispatch(
                                  SetAddressId(
                                    state.EmployeeProfile.EmployeeProfileList
                                      .address_details.id,
                                  ),
                                );
                              }

                              dispatch(SetActiveTabs(3));
                            }
                          }}
                        >
                          ID Verification Details
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          //  class="nav-link"
                          className={`  ButtonCSS nav-link  ${
                            state.FormsIDList.ActiveTabs == 4 ? "active" : ""
                          }`}
                          id="tab4"
                          data-bs-toggle="tab"
                          href="#tabs4"
                          role="tab"
                          aria-controls="tab4"
                          disabled={
                            state.EmployeeProfile.EmployeeProfileList
                              .bank_details == null ||
                            state.FormsIDList.BankDetailID == ""
                          }
                          aria-selected="false"
                          onClick={(e) => {
                            CountingFunctions(4);
                            if (
                              state.EmployeeProfile.EmployeeProfileList !=
                                undefined &&
                              state.EmployeeProfile.EmployeeProfileList !=
                                null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .bank_details != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .bank_details != undefined &&
                              state.EmployeeProfile.EmployeeProfileList.id !=
                                undefined &&
                              state.EmployeeProfile.EmployeeProfileList
                                .bank_details.id != undefined
                            ) {
                              dispatch(
                                setBankDetailsId(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .bank_details.id,
                                ),
                              );
                              dispatch(SetActiveTabs(4));
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .bank_details != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .bank_details != undefined
                            ) {
                              dispatch(SetActiveTabs(4));
                              dispatch(
                                setBankDetailsId(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .bank_details.id,
                                ),
                              );
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .bank_details == null
                            ) {
                              dispatch(setBankDetailsId(""));
                              dispatch(SetActiveTabs(4));
                            }
                          }}
                        >
                          Bank Details
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          //class="nav-link"
                          className={`  ButtonCSS nav-link  ${
                            state.FormsIDList.ActiveTabs == 5 ? "active" : ""
                          }`}
                          id="tab5"
                          data-bs-toggle="tab"
                          href="#tabs5"
                          role="tab"
                          aria-controls="tab5"
                          aria-selected="false"
                          disabled={
                            state.EmployeeProfile.EmployeeProfileList
                              .education_details == null ||
                            state.FormsIDList.EducationID == ""
                          }
                          onClick={(e) => {
                            CountingFunctions(5);
                            if (
                              state.EmployeeProfile.EmployeeProfileList !=
                                undefined &&
                              state.EmployeeProfile.EmployeeProfileList !=
                                null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .education_details != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .education_details != undefined &&
                              state.EmployeeProfile.EmployeeProfileList.id !=
                                undefined &&
                              state.EmployeeProfile.EmployeeProfileList
                                .education_details.id != undefined
                            ) {
                              dispatch(
                                SetEducationDetails(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .education_details.id,
                                ),
                              );
                              dispatch(SetActiveTabs(5));
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .education_details != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .education_details != undefined
                            ) {
                              dispatch(SetActiveTabs(5));
                              dispatch(
                                SetEducationDetails(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .education_details.id,
                                ),
                              );
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .education_details == null
                            ) {
                              dispatch(SetEducationDetails(""));
                              dispatch(SetActiveTabs(5));
                            }
                          }}
                        >
                          Education Details
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          //class="nav-link"
                          className={`  ButtonCSS nav-link  ${
                            state.FormsIDList.ActiveTabs == 6 ? "active" : ""
                          }`}
                          id="tab6"
                          data-bs-toggle="tab"
                          href="#tabs6"
                          role="tab"
                          aria-controls="tab6"
                          aria-selected="false"
                          disabled={
                            state.EmployeeProfile.EmployeeProfileList
                              .employee_previous == null ||
                            state.FormsIDList.PreviousempID == ""
                          }
                          onClick={(e) => {
                            CountingFunctions(6);
                            if (
                              state.EmployeeProfile.EmployeeProfileList
                                .employee_previous != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .employee_previous != undefined
                            ) {
                              dispatch(
                                SetPreviousEmployeeID(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .employee_previous.id,
                                ),
                              );
                              dispatch(SetActiveTabs(6));
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .employee_previous != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .employee_previous != undefined
                            ) {
                              dispatch(SetActiveTabs(6));
                              dispatch(
                                SetPreviousEmployeeID(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .employee_previous.id,
                                ),
                              );
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .employee_previous == null
                            ) {
                              dispatch(SetPreviousEmployeeID(""));
                              dispatch(SetActiveTabs(6));
                            }
                          }}
                        >
                          Previous Employment Details
                        </button>
                      </li>

                      {/* <li class="nav-item" role="presentation">
                        <button
                          //class="nav-link"
                          className={`  nav-link  ${
                            state.FormsIDList.ActiveTabs == 7 ? "active" : ""
                          }`}
                          id="tab7"
                          data-bs-toggle="tab"
                          href="#tabs7"
                          role="tab"
                          aria-controls="tab7"
                          aria-selected="false"
                          disabled={
                            state.EmployeeProfile.EmployeeProfileList
                              .family_details == null
                          }
                          onClick={(e) => {
                            CountingFunctions(7);
                            if (
                              state.EmployeeProfile.EmployeeProfileList
                                .family_details != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .family_details != undefined
                            ) {
                              dispatch(
                                setfamliydetailsid(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .family_details.id
                                )
                              );
                              dispatch(SetActiveTabs(7));
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .family_details != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .family_details != undefined
                            ) {
                              dispatch(SetActiveTabs(7));
                              dispatch(
                                setfamliydetailsid(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .family_details.id
                                )
                              );
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .family_details == null
                            ) {
                              dispatch(setfamliydetailsid(""));
                              dispatch(SetActiveTabs(7));
                            }
                          }}
                        >
                          Family Details
                        </button>
                      </li> */}

                      <li class="nav-item" role="presentation">
                        <button
                          // class="nav-link"
                          className={` ButtonCSS   nav-link  ${
                            state.FormsIDList.ActiveTabs == 8 ? "active" : ""
                          }`}
                          id="tab8"
                          data-bs-toggle="tab"
                          href="#tabs8"
                          role="tab"
                          aria-controls="tab8"
                          aria-selected="false"
                          disabled={
                            state.EmployeeProfile.EmployeeProfileList
                              .declaration_form == null ||
                            state.FormsIDList.DecalarationID == ""
                          }
                          onClick={(e) => {
                            CountingFunctions(8);
                            if (
                              state.EmployeeProfile.EmployeeProfileList
                                .declaration_form != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .declaration_form != undefined
                            ) {
                              dispatch(
                                SetDeclarationId(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .declaration_form.id,
                                ),
                              );
                              dispatch(SetActiveTabs(8));
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .declaration_form != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .declaration_form != undefined
                            ) {
                              dispatch(SetActiveTabs(8));
                              dispatch(
                                SetDeclarationId(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .declaration_form.id,
                                ),
                              );
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .declaration_form == null
                            ) {
                              dispatch(SetDeclarationId(""));
                              dispatch(SetActiveTabs(8));
                            }
                          }}
                        >
                          Declaration Form
                        </button>
                      </li>

                      <li class="nav-item" role="presentation">
                        <button
                          // class="nav-link"
                          className={` ButtonCSS  nav-link  ${
                            state.FormsIDList.ActiveTabs == 9 ? "active" : ""
                          }`}
                          id="tab9"
                          data-bs-toggle="tab"
                          href="#tabs9"
                          role="tab"
                          aria-controls="tab9"
                          aria-selected="false"
                          disabled={
                            state.EmployeeProfile.EmployeeProfileList
                              .esi_form == null ||
                            state.FormsIDList.ESIFormsid == ""
                          }
                          onClick={(e) => {
                            CountingFunctions(9);
                            if (
                              state.EmployeeProfile.EmployeeProfileList
                                .esi_form != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .esi_form != undefined
                            ) {
                              dispatch(
                                SetEsiFormIdActions(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .esi_form.id,
                                ),
                              );
                              dispatch(SetActiveTabs(9));
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .esi_form != null &&
                              state.EmployeeProfile.EmployeeProfileList
                                .esi_form != undefined
                            ) {
                              dispatch(SetActiveTabs(9));
                              dispatch(
                                SetEsiFormIdActions(
                                  state.EmployeeProfile.EmployeeProfileList
                                    .esi_form.id,
                                ),
                              );
                            } else if (
                              state.NumberCounts.Editable == 2 &&
                              state.EmployeeProfile.EmployeeProfileList
                                .esi_form == null
                            ) {
                              dispatch(SetActiveTabs(9));
                              dispatch(SetEsiFormIdActions(""));
                            }
                          }}
                        >
                          ESI Form
                        </button>
                      </li>
                    </ul>
                  </div>
                </div>

                <div className="card BeforeTabs">
                  <div className="card-body innerBody">
                    <div className="TabsStart">
                      <div className="row">
                        <div className="col-12">
                          <div className="card">
                            <div className="card-body DetailsPart">
                              <div className="tab-content" id="ex2-content">
                                <div
                                  // class=" active"
                                  className={`  tab-pane fade show   ${
                                    state.FormsIDList.ActiveTabs == 1
                                      ? "active "
                                      : ""
                                  }`}
                                  id="ex3-tabs-1"
                                  role="tabpanel"
                                  aria-labelledby="ex3-tab-1"
                                >
                                  {state.FormsIDList.ActiveTabs == 1 &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .id != undefined &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .basic_info != null &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .basic_info != undefined &&
                                  state.FormsIDList.BasicFormID ==
                                    state.EmployeeProfile.EmployeeProfileList
                                      .basic_info.id &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    "" &&
                                  state.NumberCounts.Editable == 1 ? (
                                    <BasicForms />
                                  ) : (
                                    <>
                                      {state.EmployeeProfile
                                        .EmployeeProfileList != "" &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .id != undefined &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .basic_info != null &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .basic_info != undefined &&
                                      state.NumberCounts.Editable == 2 ? (
                                        <>
                                          <BasicForms />
                                        </>
                                      ) : (
                                        <>
                                          {state.EmployeeProfile
                                            .EmployeeProfileList == "" &&
                                          state.NumberCounts.Editable == 2 ? (
                                            <>
                                              <BasicForms />
                                            </>
                                          ) : (
                                            <>
                                              {state.EmployeeProfile
                                                .EmployeeProfileList != "" &&
                                              state.NumberCounts.Editable ==
                                                2 ? (
                                                <>
                                                  <BasicForms />
                                                </>
                                              ) : (
                                                <div className="text-center">
                                                  <div className="row">
                                                    <div className="col-12">
                                                      Form is not filled
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>

                                <div
                                  //class="tab-pane fade"
                                  className={`  tab-pane fade show   ${
                                    state.FormsIDList.ActiveTabs == 2
                                      ? "active  "
                                      : ""
                                  }`}
                                  id="ex3-tabs-2"
                                  role="tabpanel"
                                  aria-labelledby="ex3-tab-2"
                                >
                                  {state.EmployeeProfile.EmployeeProfileList !=
                                    "" &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .id != undefined &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .address_details != null &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .address_details != undefined &&
                                  state.NumberCounts.Editable == 1 ? (
                                    <>
                                      <AddressForm />
                                    </>
                                  ) : (
                                    <>
                                      {state.EmployeeProfile
                                        .EmployeeProfileList == "" &&
                                      state.NumberCounts.Editable == 2 ? (
                                        <>
                                          <AddressForm />
                                        </>
                                      ) : (
                                        <>
                                          {state.EmployeeProfile
                                            .EmployeeProfileList != "" &&
                                          state.NumberCounts.Editable == 2 ? (
                                            <>
                                              <AddressForm />
                                            </>
                                          ) : (
                                            <div className="text-center">
                                              <div className="row">
                                                <div className="col-12">
                                                  Form is not filled
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>
                                <div
                                  //class="tab-pane fade"
                                  className={`  tab-pane fade show   ${
                                    state.FormsIDList.ActiveTabs == 3
                                      ? "active  "
                                      : ""
                                  }`}
                                  id="ex3-tabs-3"
                                  role="tabpanel"
                                  aria-labelledby="ex3-tabs-3"
                                >
                                  {state.FormsIDList.ActiveTabs == 3 &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    undefined &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    undefined &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    null &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .id_verification != null &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .id_verification != undefined &&
                                  // state.FormsIDList.Idverify ==
                                  //   state.EmployeeProfile.EmployeeProfileList
                                  //     .id_verification.id &&
                                  state.NumberCounts.Editable == 1 ? (
                                    <IDverify />
                                  ) : (
                                    <>
                                      {state.EmployeeProfile
                                        .EmployeeProfileList != undefined &&
                                      state.EmployeeProfile
                                        .EmployeeProfileList != undefined &&
                                      state.EmployeeProfile
                                        .EmployeeProfileList != null &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .id_verification != null &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .id_verification != undefined &&
                                      state.FormsIDList.Idverify ==
                                        state.EmployeeProfile
                                          .EmployeeProfileList.id_verification
                                          .id &&
                                      state.NumberCounts.Editable == 2 ? (
                                        <>
                                          <IDverify />
                                        </>
                                      ) : (
                                        <>
                                          {state.EmployeeProfile
                                            .EmployeeProfileList == "" &&
                                          state.NumberCounts.Editable == 2 ? (
                                            <>
                                              <IDverify />
                                            </>
                                          ) : (
                                            <>
                                              {state.EmployeeProfile
                                                .EmployeeProfileList != "" &&
                                              state.NumberCounts.Editable ==
                                                2 ? (
                                                <>
                                                  <IDverify />
                                                </>
                                              ) : (
                                                <div className="text-center">
                                                  <div className="row">
                                                    <div className="col-12">
                                                      Form is not filled
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>

                                <div
                                  // class="tab-pane fade"
                                  className={`  tab-pane fade show   ${
                                    state.FormsIDList.ActiveTabs == 4
                                      ? "active  "
                                      : ""
                                  }`}
                                  id="tabs4"
                                  role="tabpanel"
                                  aria-labelledby="ex3-tabs-3"
                                >
                                  {state.FormsIDList.ActiveTabs == 4 &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    undefined &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    undefined &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    null &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .bank_details &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .bank_details.id &&
                                  // state.FormsIDList.BankDetailID ==
                                  //   state.EmployeeProfile.EmployeeProfileList
                                  //     .bank_details.id &&
                                  state.NumberCounts.Editable == 1 ? (
                                    <BankDetails />
                                  ) : (
                                    <>
                                      {state.EmployeeProfile
                                        .EmployeeProfileList != undefined &&
                                      state.EmployeeProfile
                                        .EmployeeProfileList != null &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .bank_details &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .bank_details.id &&
                                      state.FormsIDList.BankDetailID ==
                                        state.EmployeeProfile
                                          .EmployeeProfileList.bank_details
                                          .id &&
                                      state.NumberCounts.Editable == 2 ? (
                                        <>
                                          <BankDetails />
                                        </>
                                      ) : (
                                        <>
                                          {state.EmployeeProfile
                                            .EmployeeProfileList == "" &&
                                          state.NumberCounts.Editable == 2 ? (
                                            <>
                                              <BankDetails />
                                            </>
                                          ) : (
                                            <>
                                              {state.EmployeeProfile
                                                .EmployeeProfileList != "" &&
                                              state.NumberCounts.Editable ==
                                                2 ? (
                                                <>
                                                  <BankDetails />
                                                </>
                                              ) : (
                                                <div className="text-center">
                                                  <div className="row">
                                                    <div className="col-12">
                                                      Form is not filled
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>

                                <div
                                  //class="tab-pane fade"
                                  className={`  tab-pane fade show   ${
                                    state.FormsIDList.ActiveTabs == 5
                                      ? "active  "
                                      : ""
                                  }`}
                                  id="tabs5"
                                  role="tabpanel"
                                  aria-labelledby="ex3-tabs-3"
                                >
                                  {state.FormsIDList.ActiveTabs == 5 &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    undefined &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    undefined &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    null &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .education_details &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .education_details.id &&
                                  state.FormsIDList.EducationID ==
                                    state.EmployeeProfile.EmployeeProfileList
                                      .education_details.id &&
                                  state.NumberCounts.Editable == 1 ? (
                                    <EducationDetails />
                                  ) : (
                                    <>
                                      {state.EmployeeProfile
                                        .EmployeeProfileList != null &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .education_details &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .education_details.id &&
                                      state.FormsIDList.EducationID ==
                                        state.EmployeeProfile
                                          .EmployeeProfileList.education_details
                                          .id &&
                                      state.NumberCounts.Editable == 2 ? (
                                        <>
                                          <EducationDetails />
                                        </>
                                      ) : (
                                        <>
                                          {state.EmployeeProfile
                                            .EmployeeProfileList == "" &&
                                          state.NumberCounts.Editable == 2 ? (
                                            <>
                                              <EducationDetails />
                                            </>
                                          ) : (
                                            <>
                                              {state.EmployeeProfile
                                                .EmployeeProfileList != "" &&
                                              state.NumberCounts.Editable ==
                                                2 ? (
                                                <>
                                                  <EducationDetails />
                                                </>
                                              ) : (
                                                <div className="text-center">
                                                  <div className="row">
                                                    <div className="col-12">
                                                      Form is not filled
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>

                                <div
                                  //class="tab-pane fade"
                                  className={`  tab-pane fade show   ${
                                    state.FormsIDList.ActiveTabs == 6
                                      ? "active  "
                                      : ""
                                  }`}
                                  id="tabs6"
                                  role="tabpanel"
                                  aria-labelledby="ex3-tabs-3"
                                >
                                  {state.FormsIDList.ActiveTabs == 6 &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    undefined &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    undefined &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    null &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .employee_previous &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .employee_previous.id &&
                                  state.FormsIDList.PreviousempID ==
                                    state.EmployeeProfile.EmployeeProfileList
                                      .employee_previous.id &&
                                  state.NumberCounts.Editable == 1 ? (
                                    <PreviousEmp />
                                  ) : (
                                    <>
                                      {state.EmployeeProfile
                                        .EmployeeProfileList != undefined &&
                                      state.EmployeeProfile
                                        .EmployeeProfileList != null &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .employee_previous &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .employee_previous.id &&
                                      state.FormsIDList.PreviousempID ==
                                        state.EmployeeProfile
                                          .EmployeeProfileList.employee_previous
                                          .id &&
                                      state.NumberCounts.Editable == 2 ? (
                                        <>
                                          <PreviousEmp />
                                        </>
                                      ) : (
                                        <>
                                          {state.EmployeeProfile
                                            .EmployeeProfileList == "" &&
                                          state.NumberCounts.Editable == 2 ? (
                                            <>
                                              <PreviousEmp />
                                            </>
                                          ) : (
                                            <>
                                              {state.EmployeeProfile
                                                .EmployeeProfileList != "" &&
                                              state.NumberCounts.Editable ==
                                                2 ? (
                                                <>
                                                  <PreviousEmp />
                                                </>
                                              ) : (
                                                <div className="text-center">
                                                  <div className="row">
                                                    <div className="col-12">
                                                      Form is not filled
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>
                                {/* 
                                <div
                                  //class="tab-pane fade"
                                  className={`  tab-pane fade show   ${
                                    state.FormsIDList.ActiveTabs == 7
                                      ? "active  "
                                      : ""
                                  }`}
                                  id="tabs7"
                                  role="tabpanel"
                                  aria-labelledby="ex3-tabs-3"
                                >
                                  {state.FormsIDList.ActiveTabs == 7 &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    undefined &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    undefined &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    null &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .family_details &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .family_details.id &&
                                  state.FormsIDList.FamilyDetailsId ==
                                    state.EmployeeProfile.EmployeeProfileList
                                      .family_details.id &&
                                  state.NumberCounts.Editable == 1 ? (
                                    <FamilyDetails />
                                  ) : (
                                    <>
                                      {state.EmployeeProfile
                                        .EmployeeProfileList != undefined &&
                                      state.EmployeeProfile
                                        .EmployeeProfileList != null &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .family_details &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .family_details.id &&
                                      state.FormsIDList.FamilyDetailsId ==
                                        state.EmployeeProfile
                                          .EmployeeProfileList.family_details
                                          .id &&
                                      state.NumberCounts.Editable == 2 ? (
                                        <>
                                          <FamilyDetails />
                                        </>
                                      ) : (
                                        <>
                                          {state.EmployeeProfile
                                            .EmployeeProfileList == "" &&
                                          state.NumberCounts.Editable == 2 ? (
                                            <>
                                              <FamilyDetails />
                                            </>
                                          ) : (
                                            <>
                                              {state.EmployeeProfile
                                                .EmployeeProfileList != "" &&
                                              state.NumberCounts.Editable ==
                                                2 ? (
                                                <>
                                                  <FamilyDetails />
                                                </>
                                              ) : (
                                                <div className="text-center">
                                                  <div className="row">
                                                    <div className="col-12">
                                                      Form is not filled
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </div> */}

                                <div
                                  // class="tab-pane fade"
                                  className={`  tab-pane fade show   ${
                                    state.FormsIDList.ActiveTabs == 8
                                      ? "active  "
                                      : ""
                                  }`}
                                  id="tabs8"
                                  role="tabpanel"
                                  aria-labelledby="ex3-tabs-3"
                                >
                                  {state.FormsIDList.ActiveTabs == 8 &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    undefined &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    undefined &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    null &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .declaration_form &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .declaration_form.id &&
                                  state.FormsIDList.DecalarationID ==
                                    state.EmployeeProfile.EmployeeProfileList
                                      .declaration_form.id &&
                                  state.NumberCounts.Editable == 1 ? (
                                    <DecalarationFrom />
                                  ) : (
                                    <>
                                      {state.EmployeeProfile
                                        .EmployeeProfileList != undefined &&
                                      state.EmployeeProfile
                                        .EmployeeProfileList != null &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .declaration_form &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .declaration_form.id &&
                                      state.FormsIDList.DecalarationID ==
                                        state.EmployeeProfile
                                          .EmployeeProfileList.declaration_form
                                          .id &&
                                      state.NumberCounts.Editable == 2 ? (
                                        <>
                                          <DecalarationFrom />
                                        </>
                                      ) : (
                                        <>
                                          {state.EmployeeProfile
                                            .EmployeeProfileList == "" &&
                                          state.NumberCounts.Editable == 2 ? (
                                            <>
                                              <DecalarationFrom />
                                            </>
                                          ) : (
                                            <>
                                              {state.EmployeeProfile
                                                .EmployeeProfileList != "" &&
                                              state.NumberCounts.Editable ==
                                                2 ? (
                                                <>
                                                  <DecalarationFrom />
                                                </>
                                              ) : (
                                                <div className="text-center">
                                                  <div className="row">
                                                    <div className="col-12">
                                                      Form is not filled
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>

                                <div
                                  // class="tab-pane fade"
                                  className={`  tab-pane fade show   ${
                                    state.FormsIDList.ActiveTabs == 9
                                      ? "active  "
                                      : ""
                                  }`}
                                  id="tabs9"
                                  role="tabpanel"
                                  aria-labelledby="ex3-tabs-3"
                                >
                                  {state.FormsIDList.ActiveTabs == 9 &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    undefined &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    undefined &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    null &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .esi_form &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .esi_form.id &&
                                  state.FormsIDList.ESIFormsid ==
                                    state.EmployeeProfile.EmployeeProfileList
                                      .esi_form.id &&
                                  state.NumberCounts.Editable == 1 ? (
                                    <ESIfrom />
                                  ) : (
                                    <>
                                      {state.EmployeeProfile
                                        .EmployeeProfileList != undefined &&
                                      state.EmployeeProfile
                                        .EmployeeProfileList != undefined &&
                                      state.EmployeeProfile
                                        .EmployeeProfileList != null &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .esi_form &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .esi_form.id &&
                                      state.FormsIDList.ESIFormsid ==
                                        state.EmployeeProfile
                                          .EmployeeProfileList.esi_form.id &&
                                      state.NumberCounts.Editable == 2 ? (
                                        <>
                                          <ESIfrom />
                                        </>
                                      ) : (
                                        <>
                                          {state.EmployeeProfile
                                            .EmployeeProfileList == "" &&
                                          state.NumberCounts.Editable == 2 ? (
                                            <>
                                              <ESIfrom />
                                            </>
                                          ) : (
                                            <>
                                              {state.EmployeeProfile
                                                .EmployeeProfileList != "" &&
                                              state.NumberCounts.Editable ==
                                                2 ? (
                                                <>
                                                  <ESIfrom />
                                                </>
                                              ) : (
                                                <div className="text-center">
                                                  <div className="row">
                                                    <div className="col-12">
                                                      Form is not filled
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>

                                <div
                                  // class="tab-pane fade"
                                  className={`  tab-pane fade show   ${
                                    state.FormsIDList.ActiveTabs == 10
                                      ? "active  "
                                      : ""
                                  }`}
                                  id="tabs10"
                                  role="tabpanel"
                                  aria-labelledby="ex3-tabs-3"
                                >
                                  {/* {
                                  // state.FormsIDList.ActiveTabs == 10 &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    undefined &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    undefined &&
                                  state.EmployeeProfile.EmployeeProfileList !=
                                    null &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .job_description &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .job_description.id &&
                                  // state.FormsIDList.Job_offer_id ==
                                  //   state.EmployeeProfile.EmployeeProfileList
                                  //     .job_description.id &&
                                  state.NumberCounts.Editable == 1 ? (
                                    <Joboffer />
                                  ) : (
                                    <>
                                      {
                                      
                                      state.EmployeeProfile
                                        .EmployeeProfileList != undefined &&
                                      state.EmployeeProfile
                                        .EmployeeProfileList != null &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .job_description &&
                                      state.EmployeeProfile.EmployeeProfileList
                                        .job_description.id &&
                                      state.FormsIDList.Job_offer_id ==
                                        state.EmployeeProfile
                                          .EmployeeProfileList.job_description
                                          .id &&
                                      state.NumberCounts.Editable == 2 ? (
                                        <>
                                          <Joboffer />
                                        </>




                                      ) : (
                                        <>
                                          {state.EmployeeProfile
                                            .EmployeeProfileList == "" &&
                                          state.NumberCounts.Editable == 2 ? (
                                            <>
                                              <Joboffer />
                                            </>
                                          ) : (
                                            <>
                                              {state.EmployeeProfile
                                                .EmployeeProfileList != "" &&
                                              state.NumberCounts.Editable ==
                                                2 ? (
                                                <>
                                                  <Joboffer />
                                                </>
                                              ) : (
                                                <div className="text-center">
                                                  <div className="row">
                                                    <div className="col-12">
                                                      Form is not filled
                                                    </div>
                                                  </div>
                                                </div>
                                              )}
                                            </>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )} */}
                                  {state.EmployeeProfile.EmployeeProfileList !=
                                    "" &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .id != undefined &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .job_description != null &&
                                  state.EmployeeProfile.EmployeeProfileList
                                    .job_description?.id != undefined &&
                                  state.NumberCounts.Editable == 1 ? (
                                    <>
                                      <Joboffer />
                                    </>
                                  ) : (
                                    <>
                                      {state.EmployeeProfile
                                        .EmployeeProfileList == "" &&
                                      state.NumberCounts.Editable == 2 ? (
                                        <>
                                          <Joboffer />
                                        </>
                                      ) : (
                                        <>
                                          {state.EmployeeProfile
                                            .EmployeeProfileList != "" &&
                                          state.NumberCounts.Editable == 2 ? (
                                            <>
                                              <Joboffer />
                                            </>
                                          ) : (
                                            <div className="text-center">
                                              <div className="row">
                                                <div className="col-12">
                                                  Form is not filled
                                                </div>
                                              </div>
                                            </div>
                                          )}
                                        </>
                                      )}
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormTabs;
